import React, { useState } from "react";
import {
  ItemListadoMascotasReservas,
  useListarMascotasReservasGuarderia,
} from "../../../../services/reservasGuarderiaServicios";
import TableSection from "./TableSection";
import ServerErrorModal from "../../../organisms/ServerErrorModal";
import { Model } from "../Model";
import SeleccionProductos from "../SeleccionProductos/SeleccionProductos";
import { useWizard } from "../../../../hooks/wizard";
import { Col, Row, Stack } from "react-bootstrap";
import SuccessButton from "../../../organisms/SuccessButton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

function SeleccionMascota({ model }: { model: Model }) {
  const { data, isLoading, isSuccess, error } =
    useListarMascotasReservasGuarderia();

  const { avanza, avanzar } = useWizard();

  const [newModel, setNewModel] = useState(model);

  const puedeAvanzar = newModel.idMascota;

  const onMascotaRowClick = (
    itemListadoMascotaReservas: ItemListadoMascotasReservas
  ) => {
    setNewModel((prevModel) => {
      const updatedModel: Model = {
        ...prevModel,
        idMascota: itemListadoMascotaReservas.id,
        nombreMascota: itemListadoMascotaReservas.nombre,
        propietario: itemListadoMascotaReservas.nombresPropietario,
      };
      return updatedModel;
    });
  };

  if (error) {
    return <ServerErrorModal />;
  }

  if (avanza) {
    return <SeleccionProductos model={newModel} />;
  }

  return (
    <Stack gap={2}>
      <section className="d-flex gap-2 mx-3">
        <h5>Mascota seleccionada: </h5>
        {!!newModel.nombreMascota && <h5>{newModel.nombreMascota}</h5>}
      </section>
      <TableSection
        title={"Seleccionar mascota"}
        items={data || []}
        onRowClick={onMascotaRowClick}
        isLoading={isLoading}
        isSuccess={isSuccess}
      />
      <Row className="mb-2">
        <Col className="d-flex justify-content-end">
          <SuccessButton
            type={"button"}
            style={{ width: "fit-content" }}
            disabled={!puedeAvanzar}
            onClick={avanzar}
          >
            Siguiente <ArrowForwardIcon sx={{ fontSize: 20 }} />
          </SuccessButton>
        </Col>
      </Row>
    </Stack>
  );
}

export default SeleccionMascota;
